module.exports = __webpack_public_path__ + "img/icon-dyzw.5c7ec755.png";